export const ACCESSIBILITY_TEXTS = {
    AMOUNT_BOX_RUPEE: "Amount Box Rupee {0}",
    IS_SELECTED: "is Selected",
};

export const MOST_POPULAR_TEXT = "Most Popular";

export const AMOUNT_BOX_ID = "AMOUNT_BOX_ID_{0}";
